import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = function state() {
  return {
    isSearchEngine: ''
  };
};
export default {
  namespaced: false,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};